import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';
import {
  DemoSeedConfig,
  DemoSeedContextResponse,
  DemoSeedPreviewResponse,
  DemoSeedRunResponse,
} from './demo-seed.models';

@Injectable({ providedIn: 'root' })
export class DemoSeedApiService {
  private base = `${environment.apiUrl}/cprng/demo-seed`;

  constructor(private http: HttpClient) {}

  getContext(): Observable<DemoSeedContextResponse> {
    return this.http.get<DemoSeedContextResponse>(`${this.base}/context`, {
      withCredentials: true,
    });
  }

  preview(config: DemoSeedConfig): Observable<DemoSeedPreviewResponse> {
    return this.http.post<DemoSeedPreviewResponse>(`${this.base}/preview`, config, {
      withCredentials: true,
    });
  }

  run(config: DemoSeedConfig): Observable<DemoSeedRunResponse> {
    return this.http.post<DemoSeedRunResponse>(`${this.base}/run`, config, {
      withCredentials: true,
    });
  }

  cleanup(): Observable<{ ok: boolean; deleted: Record<string, number> }> {
    return this.http.post<{ ok: boolean; deleted: Record<string, number> }>(
      `${this.base}/cleanup`,
      {},
      { withCredentials: true }
    );
  }

  resetRunning(): Observable<{ count: number; run_ids: string[] }> {
    return this.http.post<{ count: number; run_ids: string[] }>(
      `${this.base}/reset-running`,
      {},
      { withCredentials: true }
    );
  }
}
